(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                setCookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = setCookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {
    console.log("sticky full: " + sticky)

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;

          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swym-registry-manage"]) return;
  try {
    
  const swymRegistry_pageWrapper = document.getElementsByClassName("swym-registry-wrapper")[0];
  const swymRegistry_manageHeader = document.getElementsByClassName("swym-registry-manage-page-header")[0];
  const swymRegistry_manageGridLists = document.getElementsByClassName("swym-registry-manage-page-grid-section")[0];
  const swymRegistry_headerTotalRegistries = document.getElementById("swym-registry-manage-page-header-info-total-registries");
  const swymRegistry_gridLists = document.getElementById("swym-registry-manage-page-grid-lists");

 async function swymRegistryOnloadHandler() {
      if(!Shopify.designMode) {
        if(document.querySelector('#swym-registry-share-mail-link')){  
        document.querySelector('#swym-registry-share-mail-link').addEventListener('click',() => {
          _LTracker.push({
            'eventInfo': 'Share by mail button clicked - Manage',
            'tag': 'event'
          });
          Shopify.analytics.publish("swym_registry_manage_view",{"eventAction": "Share by mail button clicked","customerInfo":{
            "name"  : "{{ customer.name }}",
            "email" : "{{ customer.email }}",
            "id"    : "{{ customer.id }}"
          }});
        });
        }
        async function swymRegistry_getRegistryByEmail(authData) {
          const swymRegistry_customerEmail = swymRegistryCustomer.email;
          const token = authData.swym_registry.jwt.token
          return swymRegistry_getAllRegistries(swymRegistry_customerEmail,token)
          .then((response) => response.json())
          .then((data) => {
            if(data.length) {
              try {
                // Add total registry count & Show content
                swymRegistry_headerTotalRegistries.innerText = data.length > 1 ? data.length + " " +swymRegistryStrings.swym_registry_registries_label : data.length + " " + swymRegistryStrings.swym_registry_registry_label;

                swymRegistry_manageHeader.style.visibility = "visible";
                swymRegistry_pageWrapper.style.visibility = "visible";
                // Add Grid Lists
                data.forEach(registry => {
                  let swymRegistry_fname = registry.address.firstName, swymRegistry_lname = registry.address.lastName, swymRegistry_initials;
                  if(swymRegistry_fname && swymRegistry_lname) {
                    swymRegistry_initials = swymRegistry_fname.charAt(0) + swymRegistry_lname.charAt(0);
                  }
                  else {
                     swymRegistry_initials = registry.creatorName.charAt(0);
                  }
      
                  swymRegistry_gridLists.innerHTML += `
                    <li id="swym-registry-manage-page-grid-lists-list-${registry.Id}" class="swym-registry-manage-page-grid-lists-list">
                      <div class="swym-registry-manage-page-grid-lists-circle-parent">
                        <div class="swym-registry-manage-page-grid-lists-circle">
                          <p class="${swymRegistryStrings.swym_registry_custom_para_class } swym-registry-font-very-large">${swymRegistry_initials}</p>
                        </div>
                      </div>
                      <div class="swym-registry-manage-page-grid-lists-registry-info-parent">
                        <h3 class="swym-registry-font-sub-title">${registry.registryName}</h3>
                        <span class="swym-registry-gifter-banner-edit" onclick="swymRegistry_manageEditRegistryBtn(${registry.Id})">
                          <svg xmlns="http://www.w3.org/2000/svg" height="25" width="25" viewbox="0 0 50 50"><path d="M9 39h2.2l22.15-22.15-2.2-2.2L9 36.8Zm30.7-24.3-6.4-6.4 2.1-2.1q.85-.85 2.1-.85t2.1.85l2.2 2.2q.85.85.85 2.1t-.85 2.1Zm-2.1 2.1L12.4 42H6v-6.4l25.2-25.2Zm-5.35-1.05-1.1-1.1 2.2 2.2Z"/></svg>
                        </span>
                        <span class="swym-registry-gifter-banner-share" onclick="swymRegistryOpenShareModal(\`${registry.registryName}\`,${registry.Id},${registry.settings.isPasswordProtected},\`${registry.email}\`,\`${token}\`,\`${registry.occasion}\`)">
                          <svg xmlns="http://www.w3.org/2000/svg" height="25" width="25" viewbox="0 0 50 50"><path d="M36.35 44q-2.35 0-4.025-1.675Q30.65 40.65 30.65 38.3q0-.35.075-.825t.225-.875L15.8 27.8q-.75.85-1.85 1.375t-2.25.525q-2.35 0-4.025-1.675Q6 26.35 6 24q0-2.4 1.675-4.05T11.7 18.3q1.15 0 2.2.45 1.05.45 1.9 1.3l15.15-8.7q-.15-.35-.225-.8-.075-.45-.075-.85 0-2.4 1.675-4.05T36.35 4q2.4 0 4.05 1.65t1.65 4.05q0 2.35-1.65 4.025-1.65 1.675-4.05 1.675-1.15 0-2.225-.375Q33.05 14.65 32.3 13.8l-15.15 8.4q.1.4.175.925.075.525.075.875t-.075.75q-.075.4-.175.8l15.15 8.6q.75-.7 1.75-1.125 1-.425 2.3-.425 2.4 0 4.05 1.65t1.65 4.05q0 2.35-1.65 4.025Q38.75 44 36.35 44Zm0-31.6q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q37.5 7 36.35 7t-1.925.775q-.775.775-.775 1.925t.775 1.925q.775.775 1.925.775ZM11.7 26.7q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q12.85 21.3 11.7 21.3t-1.925.775Q9 22.85 9 24t.775 1.925q.775.775 1.925.775ZM36.35 41q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q37.5 35.6 36.35 35.6t-1.925.775q-.775.775-.775 1.925t.775 1.925Q35.2 41 36.35 41Zm0-31.3ZM11.7 24Zm24.65 14.3Z"/></svg>
                        </span>
                        <ul class="swym-registry-manage-page-grid-lists-registry-info swym-registry-font-small">
                          <li class="swym-registry-manage-page-grid-lists-registry-info-list">
                            <span>${swymRegistryStrings.swym_registry_reg_id_label}</span> : <span id="swym-registry-manage-page-info-value"><strong>${registry.Id}</strong></span>
                          </li>
                          <li class="swym-registry-manage-page-grid-lists-registry-info-list">
                            <span>${swymRegistryStrings.swym_registry_event_date_label }</span>  : <span id="swym-registry-manage-page-info-value"><strong>${registry.expiryDate}</strong></span>
                          </li>
                          <li class="swym-registry-manage-page-grid-lists-registry-info-list">
                            <span>${swymRegistryStrings.swym_registry_event_type_label }</span> : <span id="swym-registry-manage-page-info-value"><strong>${registry.occasion}</strong></span>
                          </li>
                        </ul>
                        <p class="${swymRegistryStrings.swym_registry_custom_para_class } swym-registry-manage-page-grid-lists-registry-description-title swym-registry-font-small" id="swym-registry-manage-page-grid-lists-registry-description-title-${registry.Id}"><strong>${swymRegistryStrings.swym_registry_description_label }</strong></p>
                        <p class="${swymRegistryStrings.swym_registry_custom_para_class } swym-registry-manage-page-grid-lists-registry-description swym-registry-font-small" id="swym-registry-manage-page-grid-lists-registry-description-${registry.Id}">
                          ${registry.description}
                        </p>
                        <div class="swym-registry-manage-page-grid-lists-registry-btn-parent">
                          <a class="${swymRegistryStrings.swym_registry_custom_link_class }">
                            <button class="${swymRegistryStrings.swym_registry_custom_btn_class } swym-registry-manage-page-grid-lists-registry-btn" onClick="swymRegistry_manageViewRegistryBtn(${registry.Id})">${swymRegistryStrings.swym_registry_view_registry_button_label}</button>
                          </a>
                        </div>
                      </div>
                    </li>
                  `;
                  if(registry.description.length===0){
                    document.querySelector(`#swym-registry-manage-page-grid-lists-registry-description-title-${registry.Id}`).style.display='none';
                    document.querySelector(`#swym-registry-manage-page-grid-lists-registry-description-${registry.Id}`).style.display='none';
                  }
                  return "success";
                }) 
              }
              catch (error) {
                console.error("Error in showing list of registries for user: ", error);
                return "failed";
              }
            }
            else {
              //show empty state
              try {
                const swymRegistry_emptyCardSection = document.getElementById("swym-registry-manage-page-empty-section");
  
                swymRegistry_headerTotalRegistries.innerText = "0 " + swymRegistryStrings.swym_registry_registry_label;
                swymRegistry_manageHeader.style.visibility = "visible";
                swymRegistry_pageWrapper.style.visibility = "visible";
                swymRegistry_manageGridLists.style.display = "none";
                swymRegistry_emptyCardSection.style.display = "block";
  
                document.getElementById("swym-registry-manage-page-create-btn").addEventListener("click", function(e){
                  e.preventDefault();
                  Shopify.analytics.publish("swym_registry_manage_view",{"eventAction": "Create Registry button clicked","customerInfo":{
                    "name"  : "{{ customer.name }}",
                    "email" : "{{ customer.email }}",
                    "id"    : "{{ customer.id }}"
                  }});
                  window.location = "/pages/swym-registry-form?mode=create";
                });

              } catch (error) {
                console.log("Error in Showing 'No registries found card'", error);
              }
            } 
          }).catch(error => {
             _LTracker.push({
                'ErrorLocation': 'Get all registries API call - Manage Template',
                'ErrorInfo': {
                  "error": {
                    "msg": error.message,
                    "Reference_stack": error.stack
                  }
                },
               'MerchantInfo': {
                'pid': authData.swym_registry.pid,
                'shop': Shopify.shop,
                'themeId': Shopify.theme.id,
                'themeName': Shopify.theme.name
              },
              'CustomerInfo': {
                'customerId': authData.swym_registry.customerId,
                'customerEmail': swymRegistryCustomer.email,
                 'userAgent': navigator.userAgent 
              }
              }); 
          })
        }
        
        var swymRegistry_lsInit = JSON.parse(localStorage.getItem(swymRegistry_lsName));
        const swymRegistry_authData = await swymRegistry_refreshAuth(swymRegistryCustomer, swymRegistry_lsInit);
        swymRegistry_getRegistryByEmail(swymRegistry_authData);
        document.querySelector("#swym-registry-copy-text").value = window.location.href;
      }
  };

swymRegistryAddOnloadEvent(swymRegistryOnloadHandler);

  } catch(e) { console.error(e); }
})();
})();
